export default "__VITE_ASSET__efffe8cc__"